import { XStack, YStack } from 'tamagui';

import { Slider } from '../../components/inputs/Slider';
import { SlideRulePicker } from '../../components/inputs/SlideRulePicker';
import {
    BodyMediumEmphasized,
    BodySmallRegular,
} from '../../components/text/Typography';

export const Sliders = () => {
    return (
        <YStack gap={24}>
            <BodyMediumEmphasized marginBottom={-12}>
                Slider
            </BodyMediumEmphasized>
            <XStack gap={6} alignItems="center">
                <BodySmallRegular width={70}>Neutral</BodySmallRegular>
                <Slider tone="neutral" width={250} defaultValue={[90]} />
            </XStack>
            <XStack gap={6} alignItems="center">
                <BodySmallRegular width={70}>Positive</BodySmallRegular>
                <Slider tone="positive" width={250} defaultValue={[75]} />
            </XStack>
            <XStack gap={6} alignItems="center">
                <BodySmallRegular width={70}>Warning</BodySmallRegular>
                <Slider tone="warning" width={250} defaultValue={[50]} />
            </XStack>
            <XStack gap={6} alignItems="center">
                <BodySmallRegular width={70}>Negative</BodySmallRegular>
                <Slider tone="negative" width={250} defaultValue={[25]} />
            </XStack>
            <BodyMediumEmphasized marginBottom={-12}>
                Slide Rule Picker
            </BodyMediumEmphasized>
            <XStack gap={6} alignItems="center">
                <SlideRulePicker min={1} max={100} />
            </XStack>
        </YStack>
    );
};
